import { useNavigate } from "react-router-dom";
import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";
import TestApi from "../../../Api/TestApi";
import StyledMultiSelect from "../../UI/StyledMultiSelect";
import { directus } from "../../../Api/FetchDirectus";
import { readItems } from "@directus/sdk";
import CourseBlockInterface from "../../../Interfaces/CourseBlockInterface";

const LoggedTestForm = ({ close }: TestFormInterface) => {
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState(false);
  const [complianceList, setComplianceList] = useState<
    { course_name: string; test_name: string }[] | Record<string, any>[]
  >([]);
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);

  function onClose() {
    close(false);
  }

  const fetchCourse = async () => {
    try {
      return await directus.request(readItems(`Course`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchCompliance = async () => {
    try {
      return await directus.request(readItems(`compliance`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchCourseList() {
    setCourseList([...(await fetchCourse())]);
  }

  async function fetchComplianceList() {
    setComplianceList([...(await fetchCompliance())]);
  }

  async function goTest() {
    let count = 0;

    selectedOptions.map(
      (item: { id: string; course_name: string; chosen: boolean }) => {
        if (item.chosen) {
          count++;
        }
        return count;
      }
    );

    if (count < 3) {
      setSelectedOptionsStatus(true);
    }

    if (count >= 3) {
      let selectedCompetencies = selectedOptions.filter(
        (item: { id: string; course_name: string; chosen: boolean }) =>
          item.chosen === true
      );

      let competenciesList = selectedCompetencies.map(
        (item: { id: string; course_name: string; chosen: boolean }) =>
          item.course_name
      );

      let chosenIds: string[] = [];

      competenciesList.forEach((item) => {
        courseList.forEach((course) => {
          
          if (course.title === item) {
            chosenIds.push(course.test_enter_id.toString());
          }
        });
      });
      
      const data = {
        sphere: localStorage.getItem("activity") || "",
        position: localStorage.getItem("position") || "",
        competencies: chosenIds,
      };

      setLoader(true);
      const startTest = await TestApi.startTest(data);

      if (startTest.status === 200) {
        localStorage.setItem("question", JSON.stringify(startTest.data));
        localStorage.setItem("session_code", startTest.sessionCode);
        localStorage.setItem(
          "total_question",
          JSON.stringify(startTest.totalQuestions)
        );
        localStorage.setItem("competencies_list", JSON.stringify(chosenIds));

        localStorage.removeItem("test_count");
        localStorage.removeItem("radar_data");

        window.scrollTo(0, 0);
        navigate("/intro_test");
      }

      setLoader(false);
    }
  }


  useEffect(() => {
    fetchCourseList();
    fetchComplianceList();
  }, []);

  return (
    <div className="popUp">
      <div className="popTestForm">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>

        {selectedOptionsStatus ? (
          <div className="errorText">Укажите минимум 3 компетенции</div>
        ) : null}
        <StyledMultiSelect
          text="Выбор интересующих компетенций для прохождения курса"
          optionList={complianceList}
          placeholder="Укажите минимум 3 компетенции"
          className={
            selectedOptionsStatus ? "testFormSelect error" : "testFormSelect"
          }
          list={(e: any) => setSelectedOptions(e)}
        />
        <div className="testFormStartBox">
          {" "}
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              onClick={() => goTest()}
              className="blueButton testFormButton"
              text="НАЧАТЬ ТЕСТИРОВАНИЕ"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LoggedTestForm;
